import React, { useState } from "react";
import BasicDetails from "./BasicDetails";
import SmtpDetails from "./SmtpDetails";
import { Tab, TabList } from "@fluentui/react-components";
import { convertStringToArray } from "../../../utils";

function CompanyDetails() {
  const [activeTab, setActiveTab] = useState("tab1");

  const handleTabChange = (event: any, data: any) => {
    setActiveTab(data.value);
  };

  return (
    <div>
      <TabList selectedValue={activeTab} onTabSelect={handleTabChange}>
        {!convertStringToArray(process.env.REACT_APP_HIDE_CTA_BUTTON).includes(
          "sm_basicDetails"
        ) ? (
          <Tab value="tab1">Basic Details</Tab>
        ) : (
          ""
        )}
        {!convertStringToArray(process.env.REACT_APP_HIDE_CTA_BUTTON).includes(
          "sm_communication_credentials"
        ) ? (
          <Tab value="tab2">Communication Credentials</Tab>
        ) : (
          ""
        )}
      </TabList>

      {activeTab === "tab1" && <BasicDetails />}
      {activeTab === "tab2" && <SmtpDetails />}
    </div>
  );
}

export default CompanyDetails;
